import $ from 'jquery';
import {initializeApp} from 'firebase/app';
import {getMessaging, getToken, onMessage} from 'firebase/messaging';
import Manager from 'app/notifications/manager';
import FIREBASE_CONFIG from 'app/consts/firebase';
import {addGaEvent} from 'app/ga_methods';
import {userSignedIn} from 'app/utils';

const setTokenSentToServer = currentToken => {
    window.localStorage.setItem(
        `sentFirebaseMessagingToken_${window.USER_UI_DATA.user_id}`,
        currentToken ? currentToken : ''
    );
};

const isTokenSentToServer =
        currentToken => window.localStorage.getItem(`sentFirebaseMessagingToken_${window.USER_UI_DATA.user_id}`) === currentToken;

const sendTokenToServer = currentToken => {
    if (!isTokenSentToServer(currentToken)) {
        $.post('/devices/subscribe', {token: currentToken})
            .done(() => setTokenSentToServer(currentToken));
    }
};

const initFirebase = async(config, workerUrl) => {
    const app = initializeApp(config);
    const messaging = getMessaging(app);

    try {
        const channel = new BroadcastChannel('sw_channel');
        channel.addEventListener('message', payload => {
            const userId = payload?.data?.user_id;

            if (!userId || userId === window.USER_UI_DATA.user_id.toString()) {
                Manager.callNotification((title, options) => new Notification(title, options), payload);
            }
        });

        const currentToken = await getToken(messaging, {
            serviceWorkerRegistration: await navigator.serviceWorker.register(workerUrl),
            vapidKey: config.vapidKey
        });

        if (currentToken) {
            sendTokenToServer(currentToken);
        }
    } catch (err) {
        console.error('Error when receiving the token:', err);
    }

    onMessage(messaging, payload => {
        const userId = payload?.data?.user_id;

        if (!userId || userId === window.USER_UI_DATA.user_id.toString()) {
            Manager.callNotification((title, options) => new Notification(title, options), payload);
        }
    });
};

export const notificationsAvailableInBrowser =
    () => window.Notification && Notification.requestPermission && userSignedIn();

export const notificationsStatusIsDefault =
    () => notificationsAvailableInBrowser() && Notification.permission === 'default';

export const notificationsStatusIsGranted =
    () => notificationsAvailableInBrowser();

export const requestPermission = () => {
    if (window.Notification && Notification.requestPermission && userSignedIn()) {
        const {permission} = Notification;

        const requestPermissionCallBack = result => {
            if (permission !== result) {
                addGaEvent('Browser Notification', `permission ${result}`);
            }

            if (result !== 'granted') {
                return;
            }

            initFirebase(FIREBASE_CONFIG, '/service_worker');
        };

        try {
            Notification.requestPermission().then(requestPermissionCallBack);
        } catch (error) {
            if (error instanceof TypeError) {
                Notification.requestPermission(requestPermissionCallBack);
            } else {
                throw error;
            }
        }
    }
};
